module.exports = __webpack_public_path__ + "static/media/ruler.629274ee.svg";